import React, {Component} from 'react';
import Service from "../Service";
import User from '../User';

const service = new Service();

export default class UserService{

    static GetById(clientId){
        return service.request('Patient/' + clientId).then((json) => {
            return new User(json);
        });
    }

    static Search(term){
        return service.request('Patient', {
            get:{
                term:term
            }
        })
    }

    static Save(user){
        let req = (user.clientId)? 'Patient/' + user.clientId : 'Patient';
        let options = {};
        let method = (user.clientId)? 'put':'post';
        options[method] = user;
        return service.request(req, options);
    }

    static GetAll(noCache){
        return service.request('Patient', {
            get:{
                term:''
            },
            noCache:noCache
        })
    }
}

const Pending = {};
let DetailIds = 0;

export class UserDetail extends Component{
    state = {
        value: <span className="Select-loading"></span>
    };
    id = DetailIds++;
    componentDidMount(){
        //console.log("UserDetail Did Mount:", this.props)
        //this.id = DetailIds++;
        this.loadData();
    }

    componentWillUnmount(){
        if(this.props.clientId && Pending[this.props.clientId]){
            delete Pending[this.props.clientId][this.id];
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.clientId !== this.props.clientId){
            this.loadData();
        }
    }

    loadData = ()=>{
        if(this.props.clientId){
            if(isNaN(Number(this.props.clientId))){
                this.setState({value:this.props.clientId});
                return;
            }
            if(!Pending[this.props.clientId]){
                Pending[this.props.clientId] = {};
                Pending[this.props.clientId][this.id] = this;
            }else{
                Pending[this.props.clientId][this.id] = this;
                return;
            }
            UserService.GetById(this.props.clientId).then((user) => {
                user = new User(user);
                for(let p in Pending[this.props.clientId]){
                    let ud = Pending[this.props.clientId][p];
                    ud.setUser(user);
                }
                delete Pending[this.props.clientId];
            }).catch(()=>{
                for(let p in Pending[this.props.clientId]){
                    let ud = Pending[this.props.clientId][p];
                    ud.setToNull()
                }
                delete Pending[this.props.clientId];
            })
        }else{
            this.setToNull();
        }
    }

    setUser = (user) => {
        //console.log("Setting User:", user)
        if(user){
            let val = user[this.props.detail || 'fullName'];
            if(val){
                this.setState({value:val});
            }else{
                this.setToNull();
            }
        }else{
            this.setToNull();
        }
    }

    setToNull(){
        this.setState({value:this.props.nullValue || '--'});
    }

    render(){
        return this.state.value;
    }
}


// WEBPACK FOOTER //
// ./src/api/services/UserService.js